// extracted by extract-css-chunks-webpack-plugin
module.exports = {"ellipsis-dot":"M-y-cS5rIXL1eh0DoNZEqA==","ellipsisDot":"M-y-cS5rIXL1eh0DoNZEqA==","kfShow":"_803lueYt4h3gfV7eHDoWwQ=="};